export default defineAppConfig({
  ui: {
    primary: 'emerald',
    gray: 'slate',
  },
})
